import React, { useEffect, useState } from "react";
import { api, API } from "../lib/api";
import { PageHeader } from "../components/AppLayout";
import { FileBarChart, Download, FileText, FileSpreadsheet, FileType } from "lucide-react";
import { toast } from "sonner";

const FMT_ICON = { pdf: FileText, docx: FileType, xlsx: FileSpreadsheet };
const FMT_LABEL = { pdf: "PDF", docx: "Word", xlsx: "Excel" };

export default function Reports() {
  const [types, setTypes] = useState([]);
  const [formats, setFormats] = useState(["pdf", "docx", "xlsx"]);
  const [selType, setSelType] = useState("");
  const [selFmt, setSelFmt] = useState("pdf");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/report-types").then((r) => { setTypes(r.data.types); setFormats(r.data.formats); setSelType(r.data.types[0]); })
      .catch(() => toast.error("Impossibile caricare i tipi di report"));
  }, []);

  const generate = async () => {
    setBusy(true);
    try {
      const res = await api.post("/reports/generate", { report_type: selType, fmt: selFmt }, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = `${selType.replace(/ /g, "_")}.${selFmt}`;
      document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
      toast.success("Report generato e scaricato");
    } catch (e) { toast.error("Generazione report non riuscita"); } finally { setBusy(false); }
  };

  return (
    <div className="ri-fade-in max-w-4xl">
      <PageHeader overline="Report Generator" title="Reports"
        subtitle="Genera report professionali con executive summary, tabelle, fonti e disclaimer. Export PDF, Word ed Excel." />

      <div className="rounded-xl bg-white border border-slate-200 p-6">
        <div className="ri-overline mb-2">Tipo di report</div>
        <div className="grid sm:grid-cols-2 gap-2 mb-6">
          {types.map((t) => (
            <button key={t} onClick={() => setSelType(t)} data-testid={`report-type-${t.replace(/ /g,'-').toLowerCase()}`}
              className={`text-left px-4 py-3 rounded-lg border text-sm transition-colors flex items-center gap-2 ${
                selType === t ? "border-blue-500 bg-blue-50 text-blue-800 font-medium" : "border-slate-200 hover:border-blue-300"}`}>
              <FileBarChart size={16} /> {t}
            </button>
          ))}
        </div>

        <div className="ri-overline mb-2">Formato</div>
        <div className="flex gap-2 mb-6">
          {formats.map((f) => {
            const Icon = FMT_ICON[f];
            return (
              <button key={f} onClick={() => setSelFmt(f)} data-testid={`report-fmt-${f}`}
                className={`px-4 py-2 rounded-lg border text-sm flex items-center gap-2 ${
                  selFmt === f ? "border-blue-500 bg-blue-50 text-blue-800 font-medium" : "border-slate-200"}`}>
                <Icon size={15} /> {FMT_LABEL[f]}
              </button>
            );
          })}
        </div>

        <button onClick={generate} disabled={busy || !selType} data-testid="report-generate-btn"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-blue-700 text-white font-medium hover:bg-blue-800 disabled:opacity-60">
          <Download size={17} /> {busy ? "Generazione..." : "Genera e scarica"}
        </button>
      </div>
    </div>
  );
}
